module.exports = "<article class=article-viewport><transition :duration=\"{ enter: 500, leave: 800 }\"><router-view></router-view></transition></article>";